/**
 * Google and Microsoft sign-in (spec 2026-10-31 section 6, D199). Shapes of
 * `GET auth/sso/providers`, `GET auth/sso/identities` and the codes the
 * callback sends back in `/login?sso_error=`.
 */

export type SsoProvider = 'microsoft' | 'google';

/** Display order on the login pages and the profile. */
export const SSO_PROVIDERS: readonly SsoProvider[] = ['microsoft', 'google'];

export const SSO_PROVIDER_LABEL: Record<SsoProvider, string> = {
  microsoft: 'Microsoft',
  google: 'Google',
};

export type SsoPortal = 'company' | 'employee';

export type SsoErrorCode =
  | 'no_account'
  | 'email_unverified'
  | 'no_portal_access'
  | 'admin_consent_required'
  | 'cancelled'
  | 'expired'
  | 'provider_unavailable'
  | 'link_mismatch';

export const SSO_ERROR_CODES: readonly SsoErrorCode[] = [
  'no_account',
  'email_unverified',
  'no_portal_access',
  'admin_consent_required',
  'cancelled',
  'expired',
  'provider_unavailable',
  'link_mismatch',
];

export interface SsoProviders {
  google: boolean;
  microsoft: boolean;
  microsoftAdminConsentUrl: string | null;
}

export interface SsoIdentity {
  provider: SsoProvider;
  email: string;
  createdAt: string;
  lastUsedAt: string | null;
}

export interface SsoIdentities {
  providers: { google: boolean; microsoft: boolean };
  identities: SsoIdentity[];
}

/** Public, same origin on every portal (Caddy proxies /api). */
export const SSO_API_BASE = '/api/v1/auth/sso';

/** Read once by the login page, set by the callback for `no_account`. */
export const SSO_EMAIL_COOKIE = 'kh_sso_email';
